import { Component, EventEmitter, Output } from '@angular/core';
import { LoadingController, ModalController, NavController } from 'ionic-angular';


import { Account } from '../../../model/account';

import { Organization } from '../../../model/organization';
import { NavParams } from 'ionic-angular';
import { AccountHelper } from '../../../lib/accountHelper';
import { OrganizationService } from '../../../services/organization.service';
import { Observable } from 'rxjs';
import { OrganizationSetupPage } from './organization-setup';

@Component({
    selector: 'organization-list',
    templateUrl: 'organization-list.html'
})
export class OrganizationListPage {
    accountHelper = AccountHelper.instance();
    account: Account = new Account();

    organizations: Organization[] = [];

    popoverActive: boolean;
    errorMessage: string;
    loadingData: boolean;

    textSearchChangeObservable: any;
    searchText: string;

    @Output() organizationSelected = new EventEmitter<Organization>();

    constructor(public nav: NavController, private modalCtrl: ModalController, private loadingControl: LoadingController, private organizationService: OrganizationService) {

    }

    load() {
        this.organizationService.getOrganizations()
            .then(data => {
                this.organizations = data.filter(x => AccountHelper.instance().isStaffOfOrganization(x));
            }, error => {
                this.errorMessage = "Connection Error. Please Try Again";
            });
    }

    onTextSearchChange() {
        if (!this.textSearchChangeObservable) {
            Observable.create(observer => {
                this.textSearchChangeObservable = observer;
            }).debounceTime(500)
                .distinctUntilChanged()
                .subscribe((text) => { this.search() });
        }

        this.textSearchChangeObservable.next(this.searchText);
    }

    search() {
        this.organizations = this.organizations.filter(x => x.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    }

    selectOrganization(organization: Organization) {
        if (this.nav.last()) {
            let loading = this.loadingControl.create({
                content: 'Retrieving Organization Information...',
            });

            loading.present();
            this.organizationService.getOrganization(organization.id)
                .then(data => {
                    this.loadingData = false;
                    loading.dismiss();

                    this.organizationSelected.emit(data);
                });
        }
    }

    addNewOrganization() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(OrganizationSetupPage, {}, { cssClass: 'organization-setup', enableBackdropDismiss: true });

        entryModal.present().then(() => {
            this.popoverActive = false;
        })

        entryModal.onDidDismiss((data) => {
            if (data != null) {
                if (this.nav.last()) {
                    this.organizationSelected.emit(data);
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/organization-list.ts